import React from 'react';
import { Search, Filter } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { usePackagesStore } from '../../stores/packagesStore';

type Props = {
  searchTerm: string;
  selectedGender: 'all' | 'male' | 'female';
  selectedStatus: 'all' | 'completed' | 'pending' | 'partial';
  selectedHotel: string;
  onSearchChange: (value: string) => void;
  onGenderChange: (value: 'all' | 'male' | 'female') => void;
  onStatusChange: (value: 'all' | 'completed' | 'pending' | 'partial') => void;
  onHotelChange: (value: string) => void;
};

export const TasksFilters = ({
  searchTerm,
  selectedGender,
  selectedStatus,
  selectedHotel,
  onSearchChange,
  onGenderChange,
  onStatusChange,
  onHotelChange,
}: Props) => {
  const { translations } = useLanguage();
  const { packages } = usePackagesStore();

  // Get unique hotels from packages
  const hotels = React.useMemo(() => {
    const hotelSet = new Set<string>();
    Object.values(packages).forEach(pkg => {
      if (pkg.mainMakkahHotel) hotelSet.add(pkg.mainMakkahHotel);
      if (pkg.shiftingMakkahHotel) hotelSet.add(pkg.shiftingMakkahHotel);
      if (pkg.madinahHotel) hotelSet.add(pkg.madinahHotel);
    });
    return Array.from(hotelSet).sort();
  }, [packages]);

  return (
    <></>
    // <div className="bg-white p-4 rounded-lg shadow-sm space-y-4">
    //   <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
    //     {/* Search */}
    //     <div className="relative">
    //       <input
    //         type="text"
    //         placeholder={translations?.accommodationTasks?.searchPlaceholder || 'Search by name or country...'}
    //         value={searchTerm}
    //         onChange={(e) => onSearchChange(e.target.value)}
    //         className="w-full pl-10 pr-4 py-2 border rounded-lg text-right focus:ring-2 focus:ring-primary-500"
    //       />
    //       <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
    //     </div>

    //     {/* Hotel Filter */}
    //     <select
    //       value={selectedHotel}
    //       onChange={(e) => onHotelChange(e.target.value)}
    //       className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500"
    //     >
    //       <option value="">
    //         {translations?.accommodationTasks?.filters?.allHotels || 'All Hotels'}
    //       </option>
    //       {hotels.map(hotel => (
    //         <option key={hotel} value={hotel}>{hotel}</option>
    //       ))}
    //     </select>

    //     {/* Gender Filter */}
    //     <select
    //       value={selectedGender}
    //       onChange={(e) => onGenderChange(e.target.value as 'all' | 'male' | 'female')}
    //       className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500"
    //     >
    //       <option value="all">
    //         {translations?.accommodationTasks?.filters?.allGenders || 'All Genders'}
    //       </option>
    //       <option value="male">
    //         {translations?.accommodationTasks?.filters?.male || 'Male'}
    //       </option>
    //       <option value="female">
    //         {translations?.accommodationTasks?.filters?.female || 'Female'}
    //       </option>
    //     </select>

    //     {/* Status Filter */}
    //     {/* <select
    //       value={selectedStatus}
    //       onChange={(e) => onStatusChange(e.target.value as 'all' | 'completed' | 'pending' | 'partial')}
    //       className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500"
    //     >
    //       <option value="all">
    //         {translations?.accommodationTasks?.filters?.allStatuses || 'All Statuses'}
    //       </option>
    //       <option value="completed">
    //         {translations?.accommodationTasks?.filters?.completed || 'Completed'}
    //       </option>
    //       <option value="partial">
    //         {translations?.accommodationTasks?.filters?.partial || 'Partially Accommodated'}
    //       </option>
    //       <option value="pending">
    //         {translations?.accommodationTasks?.filters?.pending || 'Pending'}
    //       </option>
    //     </select> */}
    //   </div>

    //   {/* Active Filters */}
    //   {(searchTerm || selectedGender !== 'all' || selectedStatus !== 'all' || selectedHotel) && (
    //     <div className="flex items-center gap-2">
    //       <Filter size={16} className="text-primary-500" />
    //       <span className="text-sm text-gray-600">
    //         {translations?.accommodationTasks?.filters?.activeFilters || 'Active Filters:'}
    //       </span>
    //       <div className="flex flex-wrap gap-2">
    //         {searchTerm && (
    //           <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
    //             {translations?.accommodationTasks?.filters?.search || 'Search'}: {searchTerm}
    //           </span>
    //         )}
    //         {selectedHotel && (
    //           <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
    //             {translations?.accommodationTasks?.filters?.hotel || 'Hotel'}: {selectedHotel}
    //           </span>
    //         )}
    //         {selectedGender !== 'all' && (
    //           <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
    //             {translations?.accommodationTasks?.filters?.gender || 'Gender'}: {
    //               selectedGender === 'male'
    //                 ? translations?.accommodationTasks?.filters?.male || 'Male'
    //                 : translations?.accommodationTasks?.filters?.female || 'Female'
    //             }
    //           </span>
    //         )}
    //         {selectedStatus !== 'all' && (
    //           <span className="text-xs bg-primary-50 text-primary-700 px-2 py-1 rounded">
    //             {translations?.accommodationTasks?.filters?.status || 'Status'}: {
    //               selectedStatus === 'completed'
    //                 ? translations?.accommodationTasks?.filters?.completed || 'Completed'
    //                 : selectedStatus === 'partial'
    //                 ? translations?.accommodationTasks?.filters?.partial || 'Partially Accommodated'
    //                 : translations?.accommodationTasks?.filters?.pending || 'Pending'
    //             }
    //           </span>
    //         )}
    //       </div>
    //     </div>
    //   )}
    // </div>
  );
};